@let transaction = $transaction | async;
<div class="container">
  <mat-card>
    <mat-card-content>
      @if (transaction) {
     
      <div style="position: relative">
        <display-input title="paymentId" [value]="transaction.paymentId" />
        <button
          style="position: absolute; right: 18px; top: 6px"
          mat-raised-button
          (click)="navToPaymentDetails(transaction.paymentId??'')"
        >
          Payment Details
        </button>
      </div>
      <div style="position: relative">
        <display-input title="userId" [value]="transaction.userId" />
        <button
          style="position: absolute; right: 18px; top: 6px"
          mat-raised-button
          (click)="navToUserDetails(transaction.userId??'')"
        >
          User Details
        </button>
      </div>
      <div style="position: relative">
        <display-input title="statementId" [value]="transaction.statementId" />
        <button
          style="position: absolute; right: 18px; top: 6px"
          mat-raised-button
          (click)="navToStatementDetails(transaction.userId??'', transaction.statementId??'')"
        >
          Statement Details
        </button>
      </div>
      <display-input
        title="accountReference"
        [value]="transaction.accountReference"
      />
      <display-input
        title="beneficiaryStatementReference"
        [value]="transaction.beneficiaryStatementReference"
      />
      <display-input title="amount" [value]="transaction.amount.toString()" />
      <display-input title="status" [value]="transaction.status" />

      @if(transaction.errorMessages){ @for(errorMessage of
      transaction.errorMessages; track errorMessage){
      <display-input title="Error" [value]="errorMessage" />
      } } } @if (error) {
      <app-alert (close)="error=null" class="mt-3" type="error">
        {{error}}
      </app-alert>
      } @if (!($transactionFetchedAt | async)) {
      <mat-spinner></mat-spinner>
      }
    </mat-card-content>
  </mat-card>
</div>
